import type { RemixiconComponentType } from '@remixicon/react';
import {
  RiApps2Line,
  RiCodeSSlashLine,
  RiStackLine,
  RiGlobalLine,
  RiServerLine,
  RiTeamLine,
  RiUserLine,
  RiFileAddLine,
  RiBookOpenLine,
  RiFileTextLine,
} from '@remixicon/react';

export const ENTITY_KIND_ICON: Record<string, RemixiconComponentType> = {
  component: RiApps2Line,
  api: RiCodeSSlashLine,
  system: RiStackLine,
  domain: RiGlobalLine,
  resource: RiServerLine,
  group: RiTeamLine,
  user: RiUserLine,
  template: RiFileAddLine,
};

export const ENTITY_KIND_COLOR: Record<string, string> = {
  component: '#f97316',
  api: '#a855f7',
  system: '#3b82f6',
  domain: '#22c55e',
  resource: '#64748b',
  group: '#f59e0b',
  user: '#f59e0b',
  template: '#9e9e9e',
};

export const DEFAULT_KIND_ICON: RemixiconComponentType = RiFileTextLine;
export const DEFAULT_KIND_COLOR = '#6b7280';

export const TECHDOCS_ICON: RemixiconComponentType = RiBookOpenLine;

export const getKindIcon = (kind?: string): RemixiconComponentType =>
  (kind && ENTITY_KIND_ICON[kind.toLowerCase()]) || DEFAULT_KIND_ICON;

export const getKindColor = (kind?: string): string =>
  (kind && ENTITY_KIND_COLOR[kind.toLowerCase()]) || DEFAULT_KIND_COLOR;
